module.exports = __webpack_public_path__ + "static/media/sound5.c391b45a.mp3";